import React from "react";
import { InfoTip } from "@/components/InfoTip";
import { Download, FolderOpen } from "lucide-react";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/download`;
const DOCS = [
  { slug: "plaquette-canope", title: "Plaquette Canopé", desc: "7 pages · à envoyer à Canopé", tip: "Plaquette Canopé (7 pages) : présentation, format Enseignant, exemples réels (Enseignant, fiche de révision), tarifs. À envoyer après la visio." },
  { slug: "antiseche-canope", title: "Antisèche Canopé", desc: "6 pages · pour vous uniquement", tip: "Antisèche (6 pages) : déroulé, présentation, questions probables, démo, tarifs, textes à copier-coller pour la démo. Ne pas envoyer." },
  { slug: "interface-annotee", title: "Interface annotée", desc: "Image PNG avec flèches", tip: "Image de l'interface avec flèches explicatives, à insérer dans un email ou une présentation." },
];

// Admin: secure (https) download buttons for the sales/Canopé documents.
export function AdminDocuments() {
  return (
    <section className="border border-border p-6 max-w-3xl mt-6" data-testid="admin-documents">
      <div className="sux-marker mb-2 flex items-center gap-2"><FolderOpen className="w-3 h-3" /> Documents<InfoTip testid="admin-documents-info" content={"Vos documents de communication, prêts à télécharger. Survolez une carte pour savoir à qui l'envoyer."} /></div>
      <h3 className="text-xl font-black tracking-tight mb-4" style={{ fontFamily: "Outfit" }}>Mes documents</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
        {DOCS.map((d) => (
          <a key={d.slug} href={`${BASE}/${d.slug}`} data-tip={d.tip} data-testid={`admin-doc-${d.slug}`}
            className="border border-[#002FA7] p-4 hover:bg-[#002FA7] hover:text-white transition-colors group">
            <div className="flex items-center gap-2 font-semibold"><Download className="w-4 h-4" /> {d.title}</div>
            <div className="text-xs text-muted-foreground group-hover:text-white/80 mt-1">{d.desc}</div>
          </a>
        ))}
      </div>
    </section>
  );
}

export default AdminDocuments;
